import type { StepperTokenSections, StepperDesignTokens } from '@primeuix/themes/types/stepper';

export const root: StepperTokenSections.Root = {
    transitionDuration: '{extend.transitionDuration.normal}'
};

export const separator: StepperTokenSections.Separator = {
    background: '{content.border.color}',
    activeBackground: '{primary.color}',
    margin: '0 {spacing.medium.2}',
    size: '2px'
};

export const step: StepperTokenSections.Step = {
    padding: '{spacing.small.3}',
    gap: '{spacing.medium.2}'
};

export const stepHeader: StepperTokenSections.StepHeader = {
    padding: '{spacing.medium.2}',
    borderRadius: '{borderRadius.md}',
    focusRing: {
        width: '{focus.ring.width}',
        style: '{focus.ring.style}',
        color: '{focus.ring.color}',
        offset: '{focus.ring.offset}',
        shadow: '{focus.ring.shadow}'
    },
    gap: '{spacing.medium.2}'
};

export const stepTitle: StepperTokenSections.StepTitle = {
    color: '{content.color}',
    activeColor: '{primary.color}',
    fontWeight: '600'
};

export const stepNumber: StepperTokenSections.StepNumber = {
    background: '{content.background}',
    activeBackground: '{primary.color}',
    borderColor: '{content.border.color}',
    activeBorderColor: '{primary.color}',
    color: '{content.color}',
    activeColor: '{primary.contrast.color}',
    size: '2rem',
    fontSize: '1rem',
    fontWeight: '600',
    borderRadius: '{borderRadius.xl}',
    shadow: '{overlay.popover.shadow}'
};

export const steppanels: StepperTokenSections.Steppanels = {
    padding: '{spacing.medium.3} 0'
};

export const steppanel: StepperTokenSections.Steppanel = {
    background: '{content.background}',
    color: '{content.color}',
    padding: '{spacing.medium.3}',
    indent: '1rem'
};

export default {
    root,
    separator,
    step,
    stepHeader,
    stepTitle,
    stepNumber,
    steppanels,
    steppanel
} satisfies StepperDesignTokens;
